import { UPDATE_CART } from "./actionTypes";
import { formatPrice } from "../../components/helpers/formatPrice";

export const updateCart = cartProducts => dispatch => {
	let productQuantity = cartProducts.reduce((sum, p) => {
		sum += p.quantity || 1;
		return sum;
	}, 0);

	let totalPrice = cartProducts.reduce((sum, p) => {
		if (!p.quantity) {
			p.quantity = 1;
		}

		// If item has selectedaddons (variations), use addon price as item price (replace, don't add)
		if (p.selectedaddons && p.selectedaddons.length > 0) {
			let variationPrice = p.selectedaddons.reduce((addonSum, addonArray) => {
				return addonSum + parseFloat(addonArray.price || 0);
			}, 0);
			// Variation selected but price missing/0 → use base item price (matches cart UI)
			if (!(variationPrice > 0)) {
				variationPrice = parseFloat(p.price) || 0;
			}
			sum += variationPrice * p.quantity;
		} else {
			// No variations selected, use base item price
			sum += +p.price * p.quantity;
		}

		sum = parseFloat(sum);
		formatPrice(sum);
		return sum;
	}, 0);

	let cartTotal = {
		productQuantity,
		totalPrice
	};

	dispatch({
		type: UPDATE_CART,
		payload: cartTotal
	});
};
